import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { pdfjs, Document, Page } from "react-pdf";
import styles from "./HomeContentViewer.module.scss";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.mjs`;

const PdfLoadingSkeleton = ({ name }) => (
  <div data-testid="pdf-loading-skeleton" className={styles.loading_container}>
    <div className={styles.doc_skeleton}>
      <div className={`${styles.shimmer} ${styles.sh_heading}`} />
      <div className={`${styles.shimmer} ${styles.sh_line_full}`} />
      <div className={`${styles.shimmer} ${styles.sh_line_long}`} />
      <div className={`${styles.shimmer} ${styles.sh_line_mid}`} />
      <div className={`${styles.shimmer} ${styles.sh_line_short}`} />
      <div className={`${styles.shimmer} ${styles.sh_block}`} />
      <div className={`${styles.shimmer} ${styles.sh_line_full}`} />
      <div className={`${styles.shimmer} ${styles.sh_line_long}`} />
      <div className={`${styles.shimmer} ${styles.sh_line_mid}`} />
      <hr className={styles.sh_spacer} />
      <div className={`${styles.shimmer} ${styles.sh_line_full}`} />
      <div className={`${styles.shimmer} ${styles.sh_line_long}`} />
      <div className={`${styles.shimmer} ${styles.sh_line_short}`} />
    </div>
  </div>
);

export const HomeContentViewer = () => {
  const location = useLocation();
  const contentURL = location?.state?.contentURL;
  const name = location?.state?.name;

  const [numPages, setNumPages] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(true);

  if (!contentURL) {
    return <div style={{ padding: 20 }}>No content available</div>;
  }

  const isPdf = contentURL.toLowerCase().endsWith(".pdf");

  return (
    <div className={styles.viewer_wrapper}>
      <div className={styles.content_area}>
        {isPdf ? (
          <>
            {pdfLoading && <PdfLoadingSkeleton name={name} />}
            <Document
              file={contentURL}
              onLoadSuccess={({ numPages: total }) => {
                setNumPages(total);
                setPdfLoading(false);
              }}
              onLoadError={() => setPdfLoading(false)}
              loading={null}
              error="Failed to load PDF"
            >
              {!pdfLoading && numPages &&
                Array.from(new Array(numPages), (_, index) => (
                  <Page
                    key={index}
                    pageNumber={index + 1}
                    width={window.innerWidth - 160}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                  />
                ))}
            </Document>
          </>
        ) : (
          <iframe
            src={contentURL}
            title={name || "Content Viewer"}
            style={{
              width: "100%",
              height: "100%",
              border: "none",
            }}
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          />
        )}
      </div>
    </div>
  );
};
